import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { faqs, siteInfo } from '@/mocks/site';
import HomeHero from './components/HomeHero';
import HotDig from './components/HotDig';
import CategoryGrid from './components/CategoryGrid';
import MethodSection from './components/MethodSection';
import LatestDig from './components/LatestDig';
import VoiceSection from './components/VoiceSection';
import FaqSection from './components/FaqSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: siteInfo.fullName,
      url: 'https://cicccqh.cn/',
      slogan: siteInfo.tagline,
      email: siteInfo.email,
      description: siteInfo.intro,
    },
    {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: 'https://cicccqh.cn/',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://cicccqh.cn/topics?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: { '@type': 'Answer', text: faq.answer },
      })),
    },
  ],
};

export default function Home() {
  useSeo({
    title: '爆料看料 - 深扒起底拆解，理性看清事件背后真相',
    description:
      '爆料看料专注深度拆解：深扒公开事件来龙去脉，起底行业与品牌真实逻辑，拆解隐藏细节并提供多角度分析，标注信息来源，带你穿透表象看本质。',
    keywords: '爆料看料,爆料看料深扒,爆料看料起底,爆料看料扒皮,爆料看料详解,事件深度分析',
    path: '/',
    jsonLd: homeJsonLd,
  });

  return (
    <SiteLayout>
      <HomeHero />
      <HotDig />
      <CategoryGrid />
      <MethodSection />
      <LatestDig />
      <VoiceSection />
      <FaqSection />
    </SiteLayout>
  );
}